module.exports = ":host {\n  display: block;\n  height: auto;\n  overflow-y: auto;\n  margin-bottom: 10px; }\n  :host p {\n    padding: 10px;\n    line-height: 20px; }\n  :host p img {\n      width: 100%; }\n  :host p ul {\n      list-style: Disc; }\n  :host p ul li {\n        margin: 20px; }\n  ::ng-deep ul {\n  list-style: Disc; }\n  ::ng-deep ul li {\n    margin: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-privacy-modal/alg-privacy-modal.component.scss
// module id = ./src/app/components/dialogs/alg-privacy-modal/alg-privacy-modal.component.scss
// module chunks = main